import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Col, Container } from "reactstrap";
import { defaultNgiErrorMethod, warnMessage } from "components/Common/responses/message";
import NGITable from "components/Common/NGITable";
import useStoreFilters from "customHooks/useStoreFilters";
import { FILTER_PAGE } from "utils/constants";
import { retrieveMeters } from "utils/api";
import { isEmpty } from "lodash";
import CustomButton from "components/Common/buttons/CustomButton";
import DecommissionedMetersSearch from "pages/meter-management/decommissionedMeters/DecommissionedMetersSearch";
import { decommissionedMetersListColumns } from "pages/meter-management/decommissionedMeters/DecommissionedMetersListColumns";
import BulkRetireMeterModal from "pages/meter-management/decommissionedMeters/retireModal";
import wrenchIcon from "assets/images/svg/Wrench.svg";

const DecommissionedMetersList = () => {
  const [isLoading, setLoader] = useState(false);
  const [list, setList] = useState(null);
  const { filters, setFilters } = useStoreFilters(FILTER_PAGE.DECOMMISSIONED_METERS);
  const [isBulkRetireOpen, setIsBulkRetireOpen] = useState(false);

  useEffect(() => {
    !isEmpty(filters) ? handleSearch(filters) : handleSearch();
  }, []);

  const onListLoaded = useCallback(res => {
    const {
      result: { items },
    } = res?.data;
    if (items?.length === 0) {
      warnMessage("Decommissioned meters were not found");
    }
    setList(res?.data || null);
    setLoader(false);
  }, []);

  const handleSearch = useCallback((filterOptions = {}) => {
    setLoader(true);
    const filters = { ...filterOptions };
    setFilters(filters);
    retrieveMeters({ ...filters, condition: "Decommissioned" })
      .then(res => onListLoaded(res))
      .catch(err => {
        setLoader(false);
        setList(null);
        defaultNgiErrorMethod(err);
      });
  }, []);

  const closeBulkRemove = useCallback(() => setIsBulkRetireOpen(false), []);
  const openBulkRemove = useCallback(() => setIsBulkRetireOpen(true), []);

  const columns = useMemo(() => decommissionedMetersListColumns(), []);

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <div className="filters-wrapper">
            <div className="filter-buttons">
              <CustomButton iconImg={wrenchIcon} onClick={openBulkRemove} type="primary" text="BULK RETIRE" />
            </div>

            <DecommissionedMetersSearch handleSearch={handleSearch} />
          </div>
          <Col lg={12}>
            <NGITable
              filtersType={FILTER_PAGE.DECOMMISSIONED_METERS}
              isLoading={isLoading}
              columns={columns}
              data={list}
              updateList={handleSearch}
            />
          </Col>

          {isBulkRetireOpen && <BulkRetireMeterModal onClose={closeBulkRemove} />}
        </Container>
      </div>
    </>
  );
};

export default DecommissionedMetersList;
